import Vue from "vue";
import App from "./App.vue";
import router from "./router";

Vue.config.productionTip = false;
Vue.prototype.$pages = [
  { number: 1, panel1: true, panel2: true, panel3: true },
  { number: 2, panel1: true, panel2: true, panel3: true },
  { number: 3, panel1: true, panel2: true, panel3: true },
  { number: 4, panel1: true, panel2: true, panel3: true },
  { number: 5, panel1: true, panel2: true, panel3: true },
  { number: 6, panel1: true, panel2: true, panel3: true },
  { number: 7, panel1: true, panel2: true, panel3: true },
  { number: 8, panel1: true, panel2: true, panel3: true },
  { number: 9, panel1: true, panel2: true, panel3: true },
  { number: 10, panel1: true, panel2: true, panel3: true },
  { number: 11, panel1: true, panel2: true, panel3: true },
  { number: 12, panel1: true, panel2: true, panel3: true },
  { number: 13, panel1: true, panel2: true, panel3: true },
  { number: 14, panel1: true, panel2: true, panel3: true },
  { number: 15, panel1: true, panel2: true, panel3: true },
  { number: 16, panel1: true, panel2: true, panel3: true },
  { number: 17, panel1: true, panel2: true, panel3: true },
  { number: 18, panel1: true, panel2: true, panel3: true },
  { number: 19, panel1: true, panel2: true, panel3: true },
  { number: 20, panel1: true, panel2: true, panel3: true },
  { number: 21, panel1: true, panel2: true, panel3: true },
  { number: 22, panel1: true, panel2: true, panel3: true },
  { number: 23, panel1: true, panel2: true, panel3: true },
  { number: 24, panel1: true, panel2: true, panel3: true },
  { number: 25, panel1: true, panel2: true, panel3: true },
  { number: 26, panel1: true, panel2: true, panel3: true },
  { number: 27, panel1: true, panel2: true, panel3: true },
  { number: 28, panel1: true, panel2: true, panel3: true },
  { number: 29, panel1: true, panel2: true, panel3: true },
  { number: 30, panel1: true, panel2: true, panel3: true },
  { number: 31, panel1: true, panel2: true, panel3: true },
  { number: 32, panel1: true, panel2: true, panel3: true },
  { number: 33, panel1: true, panel2: true, panel3: true },
  { number: 34, panel1: true, panel2: true, panel3: true },
  { number: 35, panel1: true, panel2: true, panel3: true },
  { number: 36, panel1: true, panel2: true, panel3: true },
  { number: 37, panel1: true, panel2: true, panel3: true },
  { number: 38, panel1: true, panel2: true, panel3: true },
  { number: 39, panel1: true, panel2: true, panel3: true },
  { number: 40, panel1: true, panel2: true, panel3: true },
  { number: 41, panel1: true, panel2: true, panel3: true },
  { number: 42, panel1: true, panel2: true, panel3: true },
  { number: 43, panel1: true, panel2: true, panel3: true },
  { number: 44, panel1: true, panel2: true, panel3: true },
  { number: 45, panel1: true, panel2: true, panel3: true },
  { number: 46, panel1: true, panel2: true, panel3: true },
  { number: 47, panel1: true, panel2: true, panel3: true },
  { number: 48, panel1: true, panel2: true, panel3: true },
  { number: 49, panel1: true, panel2: true, panel3: true },
  { number: 50, panel1: true, panel2: true, panel3: true },
  { number: 51, panel1: true, panel2: true, panel3: true },
  { number: 52, panel1: true, panel2: true, panel3: true },
  { number: 53, panel1: true, panel2: true, panel3: true },
  { number: 54, panel1: true, panel2: true, panel3: true },
  { number: 55, panel1: true, panel2: true, panel3: true },
  { number: 56, panel1: true, panel2: true, panel3: true },
  { number: 57, panel1: true, panel2: true, panel3: true },
  { number: 58, panel1: true, panel2: true, panel3: true },
  { number: 59, panel1: true, panel2: true, panel3: true },
  { number: 60, panel1: true, panel2: true, panel3: true },
  { number: 61, panel1: true, panel2: true, panel3: true },
  { number: 62, panel1: true, panel2: true, panel3: true },
  { number: 63, panel1: true, panel2: true, panel3: true },
  { number: 64, panel1: true, panel2: true, panel3: true },
  { number: 65, panel1: true, panel2: true, panel3: true },
  { number: 66, panel1: true, panel2: true, panel3: true },
  { number: 67, panel1: true, panel2: true, panel3: true },
  { number: 68, panel1: true, panel2: true, panel3: true },
  { number: 69, panel1: true, panel2: true, panel3: true },
  { number: 70, panel1: true, panel2: true, panel3: true },
  { number: 71, panel1: true, panel2: true, panel3: true },
  { number: 72, panel1: true, panel2: true, panel3: true },
  { number: 73, panel1: true, panel2: true, panel3: true },
  { number: 74, panel1: true, panel2: true, panel3: true },
  { number: 75, panel1: true, panel2: true, panel3: true },
  { number: 76, panel1: true, panel2: true, panel3: true },
  { number: 77, panel1: true, panel2: true, panel3: true },
  { number: 78, panel1: true, panel2: true, panel3: true },
  { number: 79, panel1: true, panel2: true, panel3: true },
  { number: 80, panel1: true, panel2: true, panel3: true },
  { number: 81, panel1: true, panel2: true, panel3: true },
  { number: 82, panel1: true, panel2: true, panel3: true },
  { number: 83, panel1: true, panel2: true, panel3: true },
  { number: 84, panel1: true, panel2: true, panel3: true },
  { number: 85, panel1: true, panel2: true, panel3: true },
  { number: 86, panel1: true, panel2: true, panel3: true },
  { number: 87, panel1: true, panel2: true, panel3: true },
  { number: 88, panel1: true, panel2: true, panel3: true },
  { number: 89, panel1: true, panel2: true, panel3: true },
  { number: 90, panel1: true, panel2: true, panel3: true },
  { number: 91, panel1: true, panel2: true, panel3: true },
  { number: 92, panel1: true, panel2: true, panel3: true },
  { number: 93, panel1: true, panel2: true, panel3: true },
  { number: 94, panel1: true, panel2: true, panel3: true },
  { number: 95, panel1: true, panel2: true, panel3: true },
  { number: 96, panel1: true, panel2: true, panel3: true },
  { number: 97, panel1: true, panel2: true, panel3: true },
  { number: 98, panel1: true, panel2: true, panel3: true },
  { number: 99, panel1: true, panel2: true, panel3: true },
  { number: 100, panel1: true, panel2: true, panel3: true },
  { number: 101, panel1: true, panel2: true, panel3: true },
  { number: 102, panel1: true, panel2: true, panel3: true },
  { number: 103, panel1: true, panel2: true, panel3: true },
  { number: 104, panel1: true, panel2: true, panel3: true },
  { number: 105, panel1: true, panel2: true, panel3: true },
  { number: 106, panel1: true, panel2: true, panel3: true },
  { number: 107, panel1: true, panel2: true, panel3: true },
  { number: 108, panel1: true, panel2: true, panel3: true },
  { number: 109, panel1: true, panel2: true, panel3: true },
  { number: 110, panel1: true, panel2: true, panel3: false },
];

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
